import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import useToggle from 'hooks/useToggle';
// Redux
import { useAppDispatch } from 'hooks/useStore';
import { deleteMedia } from 'store/media/mediaAsync';
import IMedia from 'models/Media';
// Components
import { IconButton } from 'components/Buttons';
import MediaPreviewDialog from 'dialogs/MediaPreview.dialog';
import ConfirmationDialog from 'dialogs/Confirmation.dialog';
// Icons
import { FaTrash, FaEye } from 'react-icons/fa';

type Props = {
  media: IMedia;
}

const MediaItem:FC<Props> = ({ media }) => {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  const handleDelete = () => {
    dispatch(deleteMedia(media._id));
  }

  const { open:openPreview, toggle:togglePreview } = useToggle();
  const { open:openDeleteDialog, toggle:toggleDeleteDialog } = useToggle();
  
  return (
    <Fragment>
      {openPreview ? (
        <MediaPreviewDialog open={openPreview} onClose={togglePreview} media={media} />
      ) : null}

      {openDeleteDialog ? (
        <ConfirmationDialog
          open={openDeleteDialog}
          onClose={toggleDeleteDialog}
          title={t('ownerPage.mediaPage.deleteMediaFile')}
          content={t('ownerPage.mediaPage.deleteMediaFileConfirmation')}
          loading={false}
          onConfirm={handleDelete}
        />
      ) : null}

      <div className="w-56 h-32 relative border">
        {media.type === 'image' ? (
          <div className="w-full h-full" style={{
            background: `url('${media.href}') center / cover`,
            cursor: 'pointer'
          }} />
        ) : (
          <video className="w-full h-full object-center object-cover" controls>
            <source src={media.href} type="video/mp4" />
          </video>
        )}
        <div className="absolute top-0 right-0 bg-gray-800 rounded">
          <IconButton size="sm" onClick={togglePreview}>
            <FaEye />
          </IconButton>
          <IconButton size="sm" onClick={toggleDeleteDialog} className="hover:text-red-600">
            <FaTrash />
          </IconButton>
        </div>
      </div>
    </Fragment>
  )
}

export default MediaItem;
